import { Link } from "react-router-dom";
import { CONTACT } from "@/data/content";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="relative bg-zinc-950 text-white overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 pt-20 md:pt-28 pb-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <span className="font-mono text-xs tracking-[0.25em] uppercase text-zinc-500">
              IT-Lösungen aus Tirol
            </span>
            <p className="mt-6 text-2xl md:text-3xl font-display font-medium max-w-xl leading-snug text-zinc-100">
              Ihre IT verdient einen Partner, der{" "}
              <span className="brand-text">mitdenkt</span>.
            </p>
            <a
              href="#kontakt"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-2 rounded-full brand-gradient text-zinc-950 text-sm font-semibold px-7 py-4 hover:opacity-90 transition-opacity duration-200"
            >
              Projekt anfragen
            </a>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-zinc-500 mb-4">
              Kontakt
            </div>
            <ul className="space-y-3 text-zinc-300">
              <li>
                <a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors" data-testid="footer-email">
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a href={CONTACT.phoneHref} className="hover:text-white transition-colors" data-testid="footer-phone">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="text-zinc-400">{CONTACT.address}</li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-zinc-500 mb-4">
              Leistungen
            </div>
            <ul className="space-y-3 text-zinc-300">
              <li><a href="#leistungen" className="hover:text-white transition-colors">On-Premises IT</a></li>
              <li><a href="#leistungen" className="hover:text-white transition-colors">Microsoft 365</a></li>
              <li><a href="#leistungen" className="hover:text-white transition-colors">IT-Security</a></li>
            </ul>
          </div>
        </div>

        {/* Huge brand mark */}
        <div className="mt-16 md:mt-24 border-t border-zinc-800 pt-10">
          <div className="font-display font-semibold tracking-tight text-[16vw] md:text-[12vw] leading-none text-transparent [-webkit-text-stroke:1.5px_#3f3f46] select-none pointer-events-none">
            inn&apos;spective
          </div>
          <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-zinc-500">
            <span>© {year} inn&apos;spective — {CONTACT.founder}. Alle Rechte vorbehalten.</span>
            <div className="flex items-center gap-6">
              <Link to="/impressum" data-testid="footer-impressum" className="hover:text-white transition-colors">Impressum</Link>
              <Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-white transition-colors">Datenschutz</Link>
              <span className="font-mono tracking-wider">THAUR · TIROL · AT</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
